
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.12 9l3.735-3.735a2.204 2.204 0 000-3.12 2.204 2.204 0 00-3.12 0L9 5.88 5.265 2.145a2.204 2.204 0 00-3.12 0 2.204 2.204 0 000 3.12L5.88 9l-3.735 3.735a2.218 2.218 0 000 3.12 2.21 2.21 0 003.12 0L9 12.12l3.735 3.735a2.211 2.211 0 003.12 0 2.218 2.218 0 000-3.12L12.12 9z","fill":"#F7F7F7"}})])
          )
        }
      }
    